import { createGlobalStyle, css } from 'styled-components';

export const fullWidthSection = css`
  margin-left: -12px;
  width: calc(100% + 24px);
  border-radius: 0;

  @media (min-width: 992px) {
    margin-left: -32px;
    width: calc(100% + 64px);
    overflow: hidden;
  }
`;

export const shadowSoft = css`
  box-shadow: rgb(0 0 0 / 15%) 0 5px 15px 0 !important;
`;

export const shadowHard = css`
  border: 2px solid rgb(0, 0, 0) !important;
  box-shadow: rgb(0 0 0) 3px 4px 0 0;
`;

export const Global = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    height: 100%;
  }

  html {
    /* Adjust font size */
    font-size: 100%;
    -webkit-text-size-adjust: 100%;
    /* Font varient */
    font-variant-ligatures: none;
    -webkit-font-variant-ligatures: none;
    /* Smoothing */
    text-rendering: optimizeLegibility;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-shadow: rgba(0, 0, 0, .01) 0 0 1px;
  }

  body {
    font-family: 'Open Sans', sans-serif !important;
    font-size: 16px;
  }
`;

export default Global;
